<template>
	<div id="Main">
		<div class="imgbox">
			<div class="title">
				<p class="p1">添加银行卡</p>
				<p style="color:red;font-size:1.5rem;">注意事项：</p>
				<p class="p2">1、红利只能转入股东本人名下银行卡，如指定的是非股东本人名下的银行卡，将导致转账失败，无法领取红利。</p>
				<p class="p2">2、如指定的银行卡为二类账户，有转账金额限制，请确保您申请领取的红利总金额不超过转账金额限制（一般为1万元，具体请咨询发卡银行）。</p>
			</div>
			<div class="box">
				<div class="inputbox">
					<span class="label">开户行</span>
					<van-field class="input iconinput" v-model="bank" placeholder="银行卡的开户银行" disabled/>
				</div>
				<div class="inputbox">
					<span class="label">卡号</span>
					<van-field class="input" v-model="card" placeholder="请点击下方拍摄银行卡" disabled />
				</div>
			</div>
			<p class="tips">拍摄银行卡</p>
			<div class="box">
				<van-uploader class="Positive" preview-size="100%" v-model="Positive" :max-count="1">
					<van-image width="100%" fit="contain" :src="require('../../assets/images/service/addcard.png')" />
				</van-uploader>
			</div>
			<!-- <div class="box">
				<van-uploader class="Positive" capture="camera" preview-size="100%" v-model="verso" :max-count="1">
					<van-image width="100%" fit="contain" :src="require('../../assets/images/service/addcard1.png')" />
				</van-uploader>
			</div> -->
			<van-button round type="info" class="submit" @click="submit">提交</van-button>
		</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				id:'',/* 银行卡id（有过有为修改需要传） */
				user:'',/* 账户号 */
				name:'',
				bank:'',
				card:'',
				Positive: [],
				verso:[],
				imgFront:'',
				imgBehind:'',
				imgcard:'',
				isCheck: true
			}
		},
		watch:{
			Positive(val) {/* 正面提交 */
				if (val.length != 0) {
					this.compressFile(val[0].file);
				
				}else{
					this.imgFront = ''
				}
			},
		},
		methods: {
			compressFile(file) { //文件压缩
					let t=this;
					var fileObj = file;
					var reader = new FileReader()
					reader.readAsDataURL(fileObj) //转base64
					reader.onload = function(e) {
						var image = new Image() //新建一个img标签（还没嵌入DOM节点)
						image.src = e.target.result
						image.onload = function() {
							var canvas = document.createElement('canvas'), // 新建canvas
								context = canvas.getContext('2d'),
								imageWidth = image.width / 2, //压缩后图片的大小
								imageHeight = image.height / 2,
								data = ''
							canvas.width = imageWidth
							canvas.height = imageHeight
							context.drawImage(image, 0, 0, imageWidth, imageHeight)
							data = canvas.toDataURL('image/jpeg') // 输出压缩后的base64
							var arr = data.split(','),
								mime = arr[0].match(/:(.*?);/)[1], // 转成blob
								bstr = atob(arr[1]),
								n = bstr.length,
								u8arr = new Uint8Array(n);
							while (n--) {
								u8arr[n] = bstr.charCodeAt(n);
							}
							let files = new window.File([new Blob([u8arr], {
								type: mime
							})], fileObj.name, {
								type: fileObj.type
							}) // 转成file					
							//callback(files) // 回调
							window.console.log('files-----', files);
							let formData = new FormData()
							formData.append('myFiles', files)
							let tpsat=t.$toast.loading({
								message: '上传中...',
								forbidClick: true,
								duration: 0
							});
							axiosPost.uploadkard(formData).then((res) => {
								tpsat.clear()
								window.console.log(res)
								if (res.data.code == 200) {
									if (res.data.data&&res.data.data!=''&&res.data.data.savePath!='') {
										t.imgFront = res.data.data.savePath
										t.imgcard = res.data.data.cardNo
										t.bank = res.data.data.bankInfo
										if(t.card==''){
											t.card=res.data.data.cardNo;
											t.$toast({duration:4000,message:'上传成功！'});
										}else{
											if(res.data.data.cardNo==t.card){
												t.$toast({duration:4000,message:'上传成功！'});
											}else{
												t.$toast({duration:4000,message:'输入的卡号和上传银行不一致！'});
											}
										}
									} else {
										t.$toast({duration:4000,message:'上传失败请重新上传！'});
										t.Positive=[]
									}
								} else {
									t.$toast({duration:4000,message:'上传失败请重新上传！'});
									t.Positive=[]
								}
							}).catch((res) => {
								tpsat.clear()
								window.console.log(res)
							})
						}
					}
			
			},
			submit() {   
				if(this.bank==''){
					this.$toast({duration:4000,message:'请填写开户银行！'});
					return false
				}
				if(this.card==''){
					this.$toast({duration:4000,message:'请填写银行卡号！'});
					return false
				}
				if(this.imgFront==''){
					this.$toast({duration:4000,message:'请上传银行卡的正面！'});
					return false
				}
				if(this.imgcard!=this.card){
					this.$toast({duration:4000,message:'输入的卡号和上传银行不一致！'});
					return false
				}
				this.$dialog.confirm({
					title: '请核对银行卡信息',
					message: `开户行   ：${this.bank} \n银行卡号：${this.card}`,
					messageAlign: 'left'
				}).then(() => {
					let data={
						shareholdeCode:this.user,
						shareholdeName:this.name,
						bank:this.bank,
						card:this.card,
						imgFront:this.imgFront,
						// imgBehind:this.imgBehind,
					}
					if(this.id!=''){
						data.id=this.id;
					}
					axiosPost.addBank(data).then((res) => {
						window.console.log(res.data)
						if (res.data.code == 200) {
							this.$router.push({
								path: '/addSuccess',
								query:{
									user:this.user,
									name:this.name,
								}
							})
						} else {
							this.$toast({duration:4000,message:res.data.msg});
						}
					}).catch((res) => {
						window.console.log(res)
					})
				}).catch(() => {
					
				})
			},
		},
		mounted() {
			this.user = this.$route.query.user
			this.name = this.$route.query.name
			if(this.$route.query.id){
				this.id = this.$route.query.id
			}
			this.$dialog.confirm({
				title: '提示',
				message: '请点击拍摄银行卡正面！直接识别，不需要手动填写卡号。'
			}).then(() => {

			}).catch(() => {
				
			})
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;
		background-color: #f2f9ff;
		min-height: 100vh;

		.popuptitle {
			display: flex;
			padding: 1.3rem;
			justify-content: space-between;
			border-bottom: 1px solid rgba(120, 120, 120, .1);
			font-size: 1.6rem;
			color: #1989fa;
		}

		.box {
			background-color: #fff;
			padding: 1rem;
			border-radius: 5px;
			font-size: 0;
			margin-bottom: 1rem;
		}

		.tips {
			font-size: 1.4rem;
			color: rgba(0, 0, 0, .5);
			padding: 1rem 0;
		}

		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin: 2rem 0;
		}

		.inputbox {
			display: flex;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;
			padding: 1rem 0;
			line-height: 2.4rem;
			position: relative;

			&:last-child {
				border-bottom: 0;
			}

			.input {
				padding: 0 1rem 0 0;
				flex: 1;
				line-height: 2.4rem;
				font-size: 1.6rem;
				padding-right: 3rem;

				input {
					color: #333333;
				}
			}

			.iconinput {}

			.label {
				font-size: 1.6rem;
				margin-right: 0.6rem;
				width: 5rem;
			}

			.icon {
				width: 2rem;
				height: 2rem;
				line-height: 2rem;
				text-align: center;
				font-size: 2rem;
				position: absolute;
				right: 0;
				top: 50%;
				z-index: 2;
				transform: translateY(-50%) rotate(90deg);
				color: #a6a6a6;
			}

		}

		.title {
			margin-bottom: 1.5rem;

			.p1 {
				font-weight: bold;
				color: #161616;
				font-size: 1.8rem;
				line-height: 2.5rem;
			}

			.p2 {
				color: #999999;
				font-size: 1.4rem;
				line-height: 2rem;
			}
		}

		.bor0 {
			border-bottom: 0;
		}

	}
</style>
